import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';

/** A component that can veto in-app navigation when it has unsaved edits. */
export interface CanComponentDeactivate {
  canDeactivate: () => boolean | Promise<boolean>;
}

/**
 * Route guard that lets a component block SPA navigation while it has unsaved
 * changes. Pairs with the component's own
 * window:beforeunload handler, which covers refresh/close/hard navigation.
 */
@Injectable({ providedIn: 'root' })
export class UnsavedChangesGuard implements CanDeactivate<CanComponentDeactivate> {
  canDeactivate(component: CanComponentDeactivate): boolean | Promise<boolean> {
    return component?.canDeactivate ? component.canDeactivate() : true;
  }
}
